import { render, staticRenderFns } from "./Farming.vue?vue&type=template&id=deb0a4f4&scoped=true&"
import script from "./Farming.vue?vue&type=script&lang=js&"
export * from "./Farming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb0a4f4",
  null
  
)

export default component.exports